import { clsx } from "clsx";
import { type FC, memo, useRef } from "react";
import { useHover } from "react-aria";
import { shallowEqual, useDispatch } from "react-redux";

import styleTrack from "../styles/Track.module.scss";

import { type TrackBedOrderedBedFile } from "../../../graphql.js";
import { getTableSpecFromTrackUsingGenomeInformation } from "../../../redux/modules/genome-browser.js";
import { type ReduxDispatch } from "../../../redux/redux-utils.js";
import { type IFeatureTrackProps } from "../features-track/FeatureTrack.js";
import { useDrawFeatures } from "../hooks/useDrawFeatures.js";
import { BedTrackHeader } from "./BedTrackHeader.js";

interface IBedTrackProps extends IFeatureTrackProps {
  bedFileData: TrackBedOrderedBedFile;
}

const BedTrack: FC<IBedTrackProps> = (props) => {
  const dispatch = useDispatch<ReduxDispatch>();
  const ref = useRef<HTMLDivElement>(null);

  const { hoverProps, isHovered } = useHover({});

  const tableQuerySpec = dispatch(
    getTableSpecFromTrackUsingGenomeInformation(props.track, props.bedFileData.bedFileId),
  );
  useDrawFeatures({ ...props, tableQuerySpec }, ref);

  const pileup = props.pileup;

  return (
    <div className={clsx(styleTrack.track, { [styleTrack.track_hovered]: isHovered })} {...hoverProps}>
      <BedTrackHeader
        track={props.track}
        bedFileId={props.bedFileData.bedFileId}
        overflow={props.overflow}
        pileup={pileup}
        showAllFeatures={props.showAllFeatures}
        isTrackHovered={isHovered}
      />
      <div className={clsx(styleTrack.container, styleTrack.container_no_top, styleTrack.container_no_bottom)}>
        <div ref={ref} />
      </div>
    </div>
  );
};

const MemoBedTrack = memo(BedTrack, shallowEqual);
export { MemoBedTrack as BedTrack };
